/* TF ATV/UTV Wheel Fitment Guide app (Horizon port, logic unchanged from Empire v4).
   Rows and notes live in assets/tf-atv-utv-data.js (window.TF_UTV_FITMENT). */
(function () {
  'use strict';
  var SRC = window.TF_UTV_FITMENT || { rows: [], notes: [] };
  var DATA = SRC.rows || [];
  var NOTES = SRC.notes || [];
  var root = document.getElementById('fgApp');
  if (!root) return;

  var BRANDS = (function () {
    var seen = {}, order = [];
    for (var i = 0; i < DATA.length; i++) {
      var b = DATA[i].brand;
      if (!(b in seen)) { seen[b] = 0; order.push(b); }
      seen[b]++;
    }
    return order.map(function (name) { return { name: name, count: seen[name] }; });
  })();

  var state = { brand: 'All', q: '' };

  function studClass(s) {
    if (!s || s === 'TBD') return 'stud-other';
    if (s.indexOf('12') !== -1) return 'stud-12';
    if (s.indexOf('10') !== -1) return 'stud-10';
    return 'stud-other';
  }
  function esc(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }
  function filtered() {
    var rows = DATA;
    if (state.brand !== 'All') rows = rows.filter(function (r) { return r.brand === state.brand; });
    if (state.q) {
      var s = state.q.toLowerCase();
      rows = rows.filter(function (r) { return (r.brand + ' ' + r.vehicle + ' ' + r.bolt + ' ' + r.years + ' ' + r.notes).toLowerCase().indexOf(s) !== -1; });
    }
    return rows;
  }
  function renderPills() {
    var html = '<button type="button" class="fg-pill ' + (state.brand === 'All' ? 'active' : '') + '" data-brand="All">All <span class="fg-pill-count">' + DATA.length + '</span></button>';
    BRANDS.forEach(function (b) {
      html += '<button type="button" class="fg-pill ' + (state.brand === b.name ? 'active' : '') + '" data-brand="' + esc(b.name) + '">' + esc(b.name) + ' <span class="fg-pill-count">' + b.count + '</span></button>';
    });
    var el = document.getElementById('fgPills');
    el.innerHTML = html;
    Array.prototype.forEach.call(el.querySelectorAll('.fg-pill'), function (btn) {
      btn.addEventListener('click', function () { state.brand = btn.getAttribute('data-brand'); renderPills(); renderTable(); });
    });
  }
  function renderSearch() {
    var el = document.getElementById('fgSearch');
    el.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
      '<input type="text" placeholder="Search vehicle or model (e.g. RZR Pro R, Pioneer 1000, KingQuad)" value="' + esc(state.q) + '" />';
    el.querySelector('input').addEventListener('input', function (e) { state.q = e.target.value; renderTable(); });
  }
  function renderTable() {
    var rows = filtered();
    var total = state.brand === 'All' ? DATA.length : DATA.filter(function (r) { return r.brand === state.brand; }).length;
    var inBrand = state.brand !== 'All' ? ' in <strong>' + esc(state.brand) + '</strong>' : '';
    document.getElementById('fgCount').innerHTML = state.q
      ? 'Showing <strong>' + rows.length + '</strong> of <strong>' + total + '</strong> vehicles' + inBrand
      : 'Showing <strong>' + rows.length + '</strong> vehicle' + (rows.length === 1 ? '' : 's') + inBrand;
    var content = document.getElementById('fgContent');
    if (!rows.length) {
      content.innerHTML = '<div class="fg-table-wrap"><div class="fg-empty"><h3>No matches found</h3><p>Try a different search term or pick a different brand.</p></div></div>';
      return;
    }
    var all = state.brand === 'All';
    var html = '<div class="fg-table-wrap"><div class="fg-table-scroll"><table><thead><tr>' + (all ? '<th>Brand</th>' : '') +
      '<th>Vehicle / Model</th><th>Bolt Pattern</th><th>Stud</th><th>Thread</th><th>Years</th><th>Notes</th></tr></thead><tbody>';
    var prev = null;
    rows.forEach(function (row) {
      var change = all && prev !== null && row.brand !== prev;
      html += '<tr' + (change ? ' class="brand-divider"' : '') + '>' +
        (all ? '<td class="brand-cell">' + esc(row.brand) + '</td>' : '') +
        '<td class="vehicle-cell">' + esc(row.vehicle) + '</td>' +
        '<td class="bolt-cell">' + esc(row.bolt) + '</td>' +
        '<td class="' + studClass(row.stud) + '">' + esc(row.stud) + '</td>' +
        '<td class="thread-cell">' + esc(row.thread) + '</td>' +
        '<td class="years-cell">' + esc(row.years) + '</td>' +
        '<td>' + (row.notes ? '<span class="note-text">' + esc(row.notes) + '</span>' : '') + '</td></tr>';
      prev = row.brand;
    });
    content.innerHTML = html + '</tbody></table></div></div>';
  }
  function renderNotes() {
    document.getElementById('fgNotes').innerHTML = NOTES.map(function (n) {
      return '<div class="fg-note-card"><h4>' + esc(n.topic) + '</h4><p>' + esc(n.detail) + '</p><span class="impact">' + esc(n.impact) + '</span></div>';
    }).join('');
  }

  renderPills();
  renderSearch();
  renderTable();
  renderNotes();
})();